// packages/shared-hooks/src/clients/useArchiveClient.ts
//
// `POST /clients/:id/archive` — archives the aggregate. Backend rejects
// child-mutations on an archived client with `CLIENT_ARCHIVED_READONLY`
// (409); the UI flips into a read-only mode after this resolves.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientDetailSchema, type ClientDetail } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useArchiveClient(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientDetail, unknown, void>({
    mutationFn: () =>
      client.post<ClientDetail>(`/clients/${id}/archive`, undefined, {}, ClientDetailSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(id) });
    },
  });
}
